import React, { Component } from "react";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebProgressbarComponent } from "../common/selltowebprogressbar/SelltoWebProgressbarComponent";

import { VehicleConditionMMRComponent } from "./VehicleConditionMMRComponent";

export class VehicleConditionRouteComponent extends Component {
    pageTitle = "Vehicle Condition";

    componentDidMount() {
        let homeData = CommonService.getSessionStorage("homeData");
        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        try {
            this.props.onPageLoad({ pageTitle: this.pageTitle });
            this.getPageInfo();
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/vehicle-condition", pageType: "Consumer", isLoggedIn: "No", properties: { vin: homeData?.vin, trim: vehicleDetailsData?.selectedTrim?.vehicleId ?? vehicleDetailsData?.selectedTrim?.description?.trim, tenantName: this.props.tenantName, siteName: this.props.siteName } });
        }
        catch (error) {
            console.logError(error, "VehicleConditionRouteComponent", "componentDidMount", homeData?.vin + " " + (vehicleDetailsData?.selectedTrim?.vehicleId ?? vehicleDetailsData?.selectedTrim?.description?.trim));
        }
    }

    getPageInfo() {
        try {
            this.props.applicationInsights.trackTrace({ message: "VehicleConditionRouteComponent/getPageInfo", properties: { tenantName: this.props.tenantName, siteName: this.props.siteName } });
            fetch("/VehicleCondition/GetPageInfo", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        usePlateToVin: parsedResponse[0].usePlateToVin
                    });
                })
                .catch(notOKResponse => {
                    this.setState({ showSpinner: false });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/VehicleCondition/GetPageInfo", ...parsedError, tenantName: this.props.tenantName, siteName: this.props.siteName } });
                                console.logError(parsedError, "VehicleConditionRouteComponent", "getPageInfo", this.state.vinOrLicensePlate.toUpperCase());
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "VehicleConditionRouteComponent", "getPageInfo", this.state.vinOrLicensePlate.toUpperCase());
                            });
                    }
                });
        } catch (error) {
            console.logError(error, "VehicleConditionRouteComponent", "getPageInfo");
        }
    }

    render() {
        let headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Vehicle Condition", "Default", "Header Html")?.Value;
        if (!headerHtml) {
            headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Header Html")?.Value ?? "";
        }

        let footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Vehicle Condition", "Default", "Footer Html")?.Value;
        if (!footerHtml) {
            footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Footer Html")?.Value ?? "";
        }
        return <div className="ac-site ac-vehiclecondition">
            <header className="ac-site-header ac-vehiclecondition-header" dangerouslySetInnerHTML={{ __html: headerHtml }} />
            <SellToWebProgressbarComponent progressIndex={4} />
            <VehicleConditionMMRComponent
                siteAttributes={this.props.siteAttributes}
                applicationInsights={this.props.applicationInsights}
            />
            <footer className="ac-site-footer ac-vehiclecondition-footer" dangerouslySetInnerHTML={{ __html: footerHtml }} />
        </div>;
    }
}